export const NAV_ITEMS = [
    {
        key: "dashboard",
        label: "Dashboard",
        iconPath:
            "M224,115.55V208a16,16,0,0,1-16,16H168a16,16,0,0,1-16-16V168a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v40a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V115.55a16,16,0,0,1,5.17-11.78l80-75.48.11-.11a16,16,0,0,1,21.53,0,1.14,1.14,0,0,0,.11.11l80,75.48A16,16,0,0,1,224,115.55Z",
    },
    {
        key: "reports",
        label: "Reports",
        iconPath:
            "M212,80a28,28,0,1,0,28,28A28,28,0,0,0,212,80Zm0,40a12,12,0,1,1,12-12A12,12,0,0,1,212,120ZM72,108a28,28,0,1,0-28,28A28,28,0,0,0,72,108ZM44,120a12,12,0,1,1,12-12A12,12,0,0,1,44,120ZM92,88A28,28,0,1,0,64,60,28,28,0,0,0,92,88Zm0-40A12,12,0,1,1,80,60,12,12,0,0,1,92,48Zm72,40a28,28,0,1,0-28-28A28,28,0,0,0,164,88Zm0-40a12,12,0,1,1-12,12A12,12,0,0,1,164,48Zm23.12,100.86a35.3,35.3,0,0,1-16.87-21.14,44,44,0,0,0-84.5,0A35.25,35.25,0,0,1,69,148.82,40,40,0,0,0,88,224a39.48,39.48,0,0,0,15.52-3.13,64.09,64.09,0,0,1,48.87,0,40,40,0,0,0,34.73-72ZM168,208a24,24,0,0,1-9.45-1.93,80.14,80.14,0,0,0-61.19,0,24,24,0,0,1-20.71-43.26,51.22,51.22,0,0,0,24.46-30.67,28,28,0,0,1,53.78,0,51.27,51.27,0,0,0,24.53,30.71A24,24,0,0,1,168,208Z",
    },
    {
        key: "blog",
        label: "Blog",
        iconPath:
            "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200Zm-40-96H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Zm0,32H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Zm-48,32H80a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z",
    },
    {
        key: "poster",
        label: "Designer",
        iconPath:
            "M200,32H56a16,16,0,0,0-16,16V232a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm0,200H56V48H200Z M184,72H72v72H184ZM168,128H88V88h80Z M176,168H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z M176,200H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z M80,8a8,8,0,0,0-8,8V64a8,8,0,0,0,16,0V16A8,8,0,0,0,80,8Z M176,8a8,8,0,0,0-8,8V64a8,8,0,0,0,16,0V16A8,8,0,0,0,176,8Z",
    },
    {
        key: "notifications",
        label: "Notifications",
        iconPath:
            "M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,0,0-160,0c0,35.33-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.33a40,40,0,0,0,79.34,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216Zm80-32H48a.13.13,0,0,1,0-.07c5.8-10,14-38.31,14-79.93a64,64,0,0,1,128,0c0,41.62,8.2,70,14,79.93A.13.13,0,0,1,208,184Z",
    },
];